import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAccess } from '@/admin/hooks';
const ProtectedRoute = ({ claims, redirectPath = '/access', children }) => {
    const { userHasAccessTo } = useAccess();
    if (claims && userHasAccessTo(...claims)) {
        return children ? children : _jsx(Outlet, {});
    }
    return _jsx(Navigate, { to: redirectPath, replace: true });
};
export { ProtectedRoute };
